import { useAvailablePaymentMethods } from '../../availablePaymentMethodsContext';
import { usePromoteFormState } from '../../formState';

export function useMoreWaysExpanded(): boolean {
	const { paymentMethods } = useAvailablePaymentMethods();
	const [{ moreWaysExpanded }] = usePromoteFormState();

	const stripeWalletPaymentsEnabled = paymentMethods.includes('applePay') || paymentMethods.includes('googlePay');

	return moreWaysExpanded || !stripeWalletPaymentsEnabled;
}
